const d = (t, s) => {
  const e = new Map(t.map((i) => [i.id, i]));
  return e.get(s.id) && s.amount < 1 ? e.delete(s.id) : e.set(s.id, s), Array.from(e.values());
};
export {
  d as updateExtras
};
